import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, MapPin } from "lucide-react";
import { Planner } from "@/components/Planner";
import { Seo } from "@/components/Seo";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PlanPage() {
  const { code } = useParams();
  const [state, setState] = useState({ status: "loading", trip: null });

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/api/plans/${code}`)
      .then(({ data }) => {
        if (alive) setState({ status: "ready", trip: data });
      })
      .catch(() => {
        if (alive) setState({ status: "notfound", trip: null });
      });
    return () => {
      alive = false;
    };
  }, [code]);

  if (state.status === "loading") {
    return (
      <main data-testid="plan-loading" className="min-h-[70vh] flex flex-col items-center justify-center gap-4 pt-20">
        <Loader2 className="animate-spin text-[#DF3226]" size={32} />
        <p className="font-body font-700 text-black/60">Loading this Copenhagen plan…</p>
      </main>
    );
  }

  if (state.status === "notfound") {
    return (
      <main data-testid="plan-notfound" className="min-h-[70vh] flex flex-col items-center justify-center gap-5 px-5 pt-20 text-center">
        <MapPin className="text-[#DF3226]" size={36} />
        <h1 className="font-display font-900 tracking-tighter text-3xl md:text-4xl">
          This plan couldn&apos;t be found
        </h1>
        <p className="font-body text-black/60 max-w-md">
          The link may be old or mistyped. You can always build a fresh Copenhagen itinerary in a
          couple of taps.
        </p>
        <Link
          to="/planner"
          data-testid="plan-build-new"
          className="inline-flex items-center gap-2 font-display font-900 text-lg bg-black text-white px-8 py-4 rounded-full shadow-brut hover:-translate-y-0.5 transition-all"
        >
          Build a plan
        </Link>
      </main>
    );
  }

  return (
    <main data-testid="plan-page">
      <Seo
        title="A Copenhagen Day Plan"
        description="A shared day-by-day Copenhagen itinerary — see the spots, tweak the days and make it your own."
        path={`/plan/${code}`}
        noindex
      />
      <Planner initialTrip={state.trip} />
    </main>
  );
}
